<template>
    <div class="dml-hero-slider-wrap"
         :class="{'dml-hero-slider-wrap--close': hasSpecialBannersBelow}">
        <div class="dml-hero-slider-wrap-center">
            <div class="dml-hero-slider">
                <table v-if="!isDateExpired" class="dml-hero-slider__timer-wrapper">
                    <tr class="_dfl" ref="countdown"></tr>
                </table>
                <div class="dml-hero-slider__item-wrap"
                     ref="imageSlider">
                    <a :href="slide.url"
                       :title="slide.name"
                       :rel="slide.isUrlNoFollow ? 'nofollow' : ''"
                       :target="slide.isUrlNoFollow ? '_blank' : '_self'"
                       v-on:mouseover="stopCycle"
                       v-on:mouseleave="startCycle(cycleTime)"
                       data-t="16.1"
                       data-ga="m_home.click_main_banner"
                       :data-ga-label="slideInfo">
                        <transition :name="animation" mode="in-out">
                            <div class="dml-hero-slider__item"
                                 :key="this.currentSlide">
                                <picture class="dml-hero-slider__item">
                                    <source :srcset="`${slide.pictures.large3x} 1x, ${slide.pictures.large4x} 2x`" media="(min-width: 1400px)">
                                    <source :srcset="`${slide.pictures.large1x} 1x, ${slide.pictures.large2x} 2x`" media="(min-width: 1280px)">
                                    <source :srcset="`${slide.pictures.medium1x} 1x, ${slide.pictures.medium2x} 2x`" media="(min-width: 720px)">
                                    <source :srcset="`${slide.pictures.small3x} 1x, ${slide.pictures.small4x} 2x`" media="(min-width: 480px)">
                                    <img :src="slide.pictures.small1x"
                                         :srcset="`${slide.pictures.small1x} 1x, ${slide.pictures.small2x} 2x`"
                                         :alt="slide.name"
                                         class="dml-hero-slider__image" />
                                </picture>
                            </div>
                        </transition>
                        <div class="dml-hero-slider__nav-wrap">
                            <div class="dml-hero-slider__nav">
                                <template v-if="showNavigation">
                                    <span v-on:click.prevent="prev" class="dml-hero-slider__arrow" title="Pokaż poprzedni" aria-label="Pokaż poprzedni" data-t="16.23">
                                        <dm-icon name="angle-left" :width="14" :height="14" />
                                    </span>
                                    <span v-on:click.prevent="next" class="dml-hero-slider__arrow" title="Pokaż następny" aria-label="Pokaż następny" data-t="16.23">
                                        <dm-icon name="angle-right" :width="14" :height="14" />
                                    </span>
                                </template>
                                <nav v-if="showNavigation" class="dml-hero-slider__indicators">
                                    <span href="javascript:void(0)" v-for="(item, index) in items" :class="{'active': isActive(index)}" v-on:click.prevent="indicatorClick(index)" :aria-label="`Baner numer  ${index}`"></span>
                                </nav>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { timer } from '~/utils/timer.js';
    import { SwipeDetect } from '~/utils/swipe-detect.js';
    import { isHighDensity } from '~/utils/high-resolution';
    import * as screenSizes from '~/utils/screen-sizes';
    import IconComponent from '../shared/icon-component.vue';
    const Direction = {
        NEXT: 0,
        PREV: 1
    };
    const Animation = {
        LEFT: 'a-slide-left',
        RIGHT: 'a-slide-right'
    };
    export default {
        name: 'dm-hero-slider',
        components: {
            'dm-icon': IconComponent,
        },
        props: {
            items: {
                type: Array,
                required: true
            },
            slots: {
                type: Number,
                default: 1
            },
            cycleTime: {
                type: Number,
                default: 5000
            },
            preload: {
                type: Object,
                default: null
            },
        },
        data() {
            return {
                currentSlide: 0,
                timer: null,
                direction: Direction.NEXT,
            };
        },
        computed: {
            animation() {
                return this.direction === Direction.NEXT ? Animation.LEFT : Animation.RIGHT;
            },
            slide() {
                return this.items[this.currentSlide];
            },
            slideInfo() {
                return `${this.currentSlide + 1}_${this.slide.name}`;
            },
            showNavigation() {
                return this.items.length > this.slots;
            },
            hasSpecialBannersBelow() {
                return DM.Boot.MainPage.mainPageSpecialBanners && !!DM.Boot.MainPage.mainPageSpecialBanners.specialBanners;
            },
            isCounter() {
                return !!this.slide.counterDateTo;
            },
            isDateExpired() {
                if (this.isCounter) {
                    const now = new Date().getTime();
                    const end = new Date(this.slide.counterDateTo).getTime();
                    const diff = end - now;
                    return diff <= 0;
                }
                return true;
            }
        },
        created() {
            if (this.preload) {
                this.preloadImages();
            }
        },
        mounted() {
            this.addSwipeEventListener();
            this.updateTimer();
        },
        destroyed() {
            this.removeSwipeEventListener();
        },
        watch: {
            items() {
                if (this.preload) {
                    this.preloadImages();
                }
            }
        },
        methods: {
            startCycle(time) {
                if (time > 0) {
                    this.timer = window.setInterval(this.next.bind(this), time);
                }
            },
            stopCycle() {
                window.clearInterval(this.timer);
            },
            resetCycle() {
                this.stopCycle();
                this.startCycle(this.cycleTime);
            },
            next() {
                this.resetCycle();
                this.currentSlide = (this.currentSlide + this.slots) % this.items.length;
                this.direction = Direction.NEXT;

                this.updateTimer();
            },
            prev() {
                this.resetCycle();
                const newCurrent = this.currentSlide - this.slots;
                const lastSlide = this.items.length - 1;
                this.currentSlide = newCurrent < 0 ? lastSlide : newCurrent;
                this.direction = Direction.PREV;

                this.updateTimer();
            },
            preloadImages() {
                if (this.preload.sequentially) {
                    this.preloadImagesSeq(0);
                }
            },
            preloadImagesSeq(position) {
                const item = this.items.filter((item, index) => index === position)[0];
                if (item) {
                    const img = new Image();
                    img.src = this.getImageToPreload(item);
                    img.onload = () => {
                        if (position === 0) {
                            this.startCycle(this.cycleTime);
                        }
                        const newPosition = position + 1;
                        if (this.items.length > newPosition) {
                            this.preloadImagesSeq(newPosition);
                        }
                    };
                }
            },
            getImageToPreload(slide) {
                if (screenSizes.isSmallScreen()) {
                    return isHighDensity ? slide.pictures.small2x : slide.pictures.small1x;
                } else if (screenSizes.isSmallPlusScreen()) {
                    return isHighDensity ? slide.pictures.small4x : slide.pictures.small3x;
                } else if (screenSizes.isMediumScreen()) {
                    return isHighDensity ? slide.pictures.medium2x : slide.pictures.medium1x;
                } else if (screenSizes.isLargeScreen()) {
                    return isHighDensity ? slide.pictures.large2x : slide.pictures.large1x;
                } else {
                    return isHighDensity ? slide.pictures.large4x : slide.pictures.large3x;
                }
            },
            addSwipeEventListener() {
                const slider = this.$refs.imageSlider;
                this.swipe = new SwipeDetect(slider, 'horizontal', swipeDirection => {
                    if (swipeDirection === 'left') {
                        this.next();
                    } else if (swipeDirection === 'right') {
                        this.prev();
                    }
                });
            },
            removeSwipeEventListener() {
                if (this.swipe) {
                    this.swipe.removeEvents();
                }
            },
            indicatorClick(index) {
                this.resetCycle();
                if (index === 0 || index < this.currentSlide) {
                    this.direction = Direction.PREV;
                } else {
                    this.direction = Direction.NEXT;
                }
                this.currentSlide = index;
            },
            isActive(index) {
                return this.currentSlide === index;
            },
            updateTimer() {
                if (!this.isDateExpired) {
                    const unixDate = new Date(this.slide.counterDateTo).getTime();

                    this.$nextTick(() => {
                        timer(this.$refs.countdown, unixDate,
                            'dml-hero-slider__timer-element', 'dml-hero-slider__timer-value', 'dml-hero-slider__timer-name');
                    })
                }
            }
        },
    };
</script>
